const singleRoomLongTermPriceWrapper = document.querySelector('.single-room-long-price');
if (singleRoomLongTermPriceWrapper) {

    const url =  window.location.search;
    const urlParams = new URLSearchParams(url);

    const season = urlParams.get('season');
    const room_id = urlParams.get('room_id');
    const term = urlParams.get('term');


    const data = new FormData();
    data.append('action', 'get_room_data');
    data.append('season', season);
    data.append('roomId', room_id);
    data.append('post_id', ajaxObject.post_id)
    data.append('nonce', ajaxObject.nonce);

    fetchRoomData(data);
}


function fetchRoomData(data){
    fetch(ajaxObject.ajax_url, {
        method: "POST",
        // credentials: 'same-origin',
        body: data
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`[${response.status}] ${response.statusText}`);
            }
            return response.json();
        })
        .then(response => {
            singleRoomLongTermPriceWrapper.innerHTML = response.data.html;

        })
        .catch(error => {
            console.error(error);
        });
}